(() => {
  const init = () => {
    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    const sticky = document.querySelector('[data-tranq-pdp-sticky]');
    if (!productInfo || !sticky || sticky.dataset.ready) return;
    sticky.dataset.ready = 'true';

    const servingPrice = productInfo.querySelector('[data-tranq-serving-price]');
    const stickyPrice = sticky.querySelector('[data-tranq-sticky-price]');
    const primaryButton = productInfo.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]');
    const stickyButton = sticky.querySelector('[data-tranq-sticky-add]');

    const normalizeReviewProductTitle = () => {
      const oldTitle = 'Tranquilitas™ | Zero-Sugar Calm Support Drink Mix';
      const currentTitle = productInfo.querySelector('.product__title h1')?.textContent.trim();
      if (!currentTitle) return;
      document.querySelectorAll('.jdgm-widget, .jdgm-revs-tab, [class*="jdgm"]').forEach((root) => {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (node.nodeValue.includes(oldTitle)) node.nodeValue = node.nodeValue.replaceAll(oldTitle, currentTitle);
        }
      });
    };

    const moneyParts = (text) => {
      const matches = [...String(text || '').matchAll(/[$£€]\s?[\d,.]+/g)];
      return matches.length ? matches[matches.length - 1][0] : '';
    };

    const rechargeRoot = () => productInfo.querySelector('recharge-subscription-widget')?.shadowRoot;

    const selectedPurchasePrice = () => {
      const roots = [rechargeRoot(), productInfo].filter(Boolean);
      for (const root of roots) {
        for (const checked of root.querySelectorAll('input[type="radio"]:checked')) {
          const choice = checked.closest('label, [role="radio"], .rc-radio, .recharge-subscription-widget-option');
          const choicePrice = moneyParts(choice?.textContent);
          if (choicePrice) return choicePrice;
        }
      }

      const basePriceCents = Number(servingPrice?.dataset.tranqBasePriceCents || 0);
      if (basePriceCents > 0) {
        const currencySymbol = stickyPrice?.textContent.match(/[$£€]/)?.[0] || '$';
        return `${currencySymbol}${(basePriceCents / 100).toFixed(2)}`;
      }

      for (const checked of productInfo.querySelectorAll('input[type="radio"]:checked')) {
        const choice = checked.closest('label, [role="radio"], .rc-radio, .recharge-subscription-widget-option');
        const choicePrice = moneyParts(choice?.textContent);
        if (choicePrice) return choicePrice;
      }
      return '';
    };

    const updatePrices = () => {
      const priceText = selectedPurchasePrice();
      const numeric = Number(priceText.replace(/[^\d.]/g, ''));
      if (!priceText || !Number.isFinite(numeric)) return;
      if (stickyPrice) stickyPrice.textContent = priceText;
      if (servingPrice) {
        const symbol = priceText.match(/[$£€]/)?.[0] || '$';
        const servingText = `20 stick packs · ${symbol}${(numeric / 20).toFixed(2)}/serving`;
        if (servingPrice.textContent.trim() !== servingText) servingPrice.textContent = servingText;
      }
    };

    const setButtonState = () => {
      if (!primaryButton || !stickyButton) return;
      stickyButton.disabled = primaryButton.disabled;
      stickyButton.textContent = primaryButton.textContent.trim() || 'Add to cart';
    };

    stickyButton?.addEventListener('click', () => primaryButton?.click());
    productInfo.addEventListener('change', () => requestAnimationFrame(updatePrices));
    new MutationObserver(() => {
      updatePrices();
      setButtonState();
    }).observe(productInfo, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['checked', 'disabled', 'aria-checked'] });

    let rechargeAttempts = 0;
    const connectRecharge = () => {
      const root = rechargeRoot();
      if (!root) {
        if (rechargeAttempts++ < 40) window.setTimeout(connectRecharge, 100);
        return;
      }
      if (!root.__tranqPriceReady) {
        root.__tranqPriceReady = true;
        root.addEventListener('change', () => window.setTimeout(updatePrices, 0));
        new MutationObserver(updatePrices).observe(root, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['checked', 'rc-selected', 'rc-not-selected']
        });
      }
      updatePrices();
    };

    const buyBox = primaryButton?.closest('.product-form') || productInfo;
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0 }).observe(buyBox);

    const reviewWidget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    if (reviewWidget) reviewWidget.id = 'tranq-reviews';
    document.querySelector('[data-tranq-rating-link]')?.addEventListener('click', (event) => {
      const target = document.querySelector('#tranq-reviews, #judgeme_product_reviews, .jdgm-review-widget');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    updatePrices();
    connectRecharge();
    setButtonState();
    normalizeReviewProductTitle();
    let reviewTitleAttempts = 0;
    const reviewTitleTimer = window.setInterval(() => {
      normalizeReviewProductTitle();
      if (++reviewTitleAttempts >= 12) window.clearInterval(reviewTitleTimer);
    }, 500);
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
